/**
 * Environment Configuration
 * Centralizes all environment-specific settings
 */

const ENV = process.env.NODE_ENV || 'development';

// Base configuration
const config = {
  app: {
    name: 'بوابة الليطاني - Litani Gateway',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    description: 'Official municipality app for Qaqaaiyat Al Jiser',
  },
  
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || '',
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000,
  },
  
  storage: {
    prefix: process.env.REACT_APP_STORAGE_PREFIX || 'litani_gateway_',
  },
  
  social: {
    playStoreUrl: process.env.REACT_APP_PLAY_STORE_URL || 'https://play.google.com/store/apps/details?id=com.cave.litanigateway',
    appStoreUrl: process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/lb/app/بوابة-الليطاني/id6753323742',
  },
  
  analytics: {
    googleAnalyticsId: process.env.REACT_APP_GA_ID || '',
    enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  },
  
  features: {
    enableContactForm: process.env.REACT_APP_ENABLE_CONTACT_FORM !== 'false',
    enableNews: process.env.REACT_APP_ENABLE_NEWS !== 'false',
    enableNotifications: process.env.REACT_APP_ENABLE_NOTIFICATIONS !== 'false',
  },
  
  debug: {
    enableConsoleLog: ENV === 'development',
    enableErrorReporting: ENV === 'production',
  }
};

// Environment-specific overrides
const environments = {
  development: {
    debug: {
      enableConsoleLog: true,
      enableErrorReporting: false,
    },
    api: {
      baseUrl: 'http://localhost:3001/api',
    }
  },
  
  staging: {
    debug: {
      enableConsoleLog: false,
      enableErrorReporting: true,
    },
    api: {
      baseUrl: 'https://staging-api.qaqaaiyataljiser.com/api',
    }
  },
  
  production: {
    debug: {
      enableConsoleLog: false,
      enableErrorReporting: true,
    },
    api: {
      baseUrl: 'https://api.qaqaaiyataljiser.com/api',
    },
    analytics: {
      enableAnalytics: true,
    }
  }
};

// Merge base config with environment-specific config
const environmentConfig = environments[ENV] || {};
const mergedConfig = {
  ...config,
  ...environmentConfig,
  app: { ...config.app, ...environmentConfig.app },
  api: { ...config.api, ...environmentConfig.api },
  storage: { ...config.storage, ...environmentConfig.storage },
  social: { ...config.social, ...environmentConfig.social },
  analytics: { ...config.analytics, ...environmentConfig.analytics },
  features: { ...config.features, ...environmentConfig.features },
  debug: { ...config.debug, ...environmentConfig.debug },
};

// Add computed properties
mergedConfig.isDevelopment = ENV === 'development';
mergedConfig.isStaging = ENV === 'staging';
mergedConfig.isProduction = ENV === 'production';
mergedConfig.environment = ENV;

export default mergedConfig;